import PackagesModalContainer from './PackagesModalContainer';

export default PackagesModalContainer;



// WEBPACK FOOTER //
// ./src/components/molecules/PackagesModal/index.js